import {createSlice} from '@reduxjs/toolkit'

const initialState = {
    open: false,
    items: [
        // {
        //     title: 'Webinar', 
        //     url: '/webinars'
        // }
    ]
}

export const breadcrumbReducer = createSlice({
    name: 'loader', 
    initialState, 
    reducers: {
        setBreadcrumb: (state, action) => {
            state.open = action.payload
        },
        setBreadcrumbItems: (state, action) => {
            state.items = action.payload
        }
    }
})

export const {setBreadcrumb, setBreadcrumbItems} = breadcrumbReducer.actions
export default breadcrumbReducer.reducer